<template>
  <v-container fluid mb-12 mt-5 style="width: 90%">
    <v-row>
      <v-col sm="3" md="6" offset-lg="0">
        <h1>Documents</h1>
        <v-spacer></v-spacer>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="flex-container mb-1">
        <v-spacer></v-spacer>
        <v-btn
          v-if="tableDisplay == `documents`"
          color="primary"
          dark
          rounded
          small
          class="flex-c"
          @click="dialog = true"
        >
          Upload Document
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          v-if="tableDisplay == `document_types`"
          color="primary"
          dark
          rounded
          small
          class="flex-c"
          @click="typeDialog = true"
        >
          Create Document Type
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          v-if="tableDisplay == `document_categories`"
          color="primary"
          dark
          rounded
          small
          class="flex-c"
          @click="categoryDialog = true"
        >
          Create Category
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          v-if="tableDisplay == `senders`"
          color="primary"
          dark
          rounded
          small
          class="flex-c"
          @click="senderDialog = true"
        >
          Create Sender
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <hr />
    <div class="v-row">
      <v-col cols="6">
        <v-btn-toggle
          v-model="tableDisplay"
          tile
          color="deep-purple accent-3"
          group
          class="text-center"
          rounded
          mandatory
        >
          <v-btn v-if="loggedInPosition == 'Admin' || loggedInPosition == 'Regional Director' || loggedInPosition == 'Records Officer' || loggedInPosition == 'Regional Employee' || loggedInPosition == 'Office Head'" value="documents"> Documents </v-btn>
          <v-btn v-if="loggedInPosition == 'Admin' || loggedInPosition == 'Regional Director' || loggedInPosition == 'Records Officer' || loggedInPosition == 'Office Head'" value="document_types"> Document Types </v-btn>
          <v-btn v-if="loggedInPosition == 'Admin' || loggedInPosition == 'Regional Director' || loggedInPosition == 'Records Officer' || loggedInPosition == 'Office Head'" value="document_categories"> Document Categories </v-btn>
          <v-btn value="senders">
            Senders
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </div>
    <DocumentTable @closeDialog="closeDialog" :dialog="dialog" :isFetching="isFetchingDocuments" :search="search" :dateRange="dateRange" :category="category" :type="types" :tableDisplay="tableDisplay" />
    <DocumentTypesTable @openDialog="openDialog" @closeDialog="closeDialog" :dialog="typeDialog" :isFetching="isFetchingDocumentsTypes" :search="search" :tableDisplay="tableDisplay" />
    <InitiatedDocumentTable :search="search" :tableDisplay="tableDisplay" />
    <DocumentCategoriesList @openDialog="openDialog" @closeDialog="closeDialog" :dialog="categoryDialog" :isFetching="isFetchingDocumentsCategories" :search="search" :tableDisplay="tableDisplay" />
    <SendersTable @closeDialog="closeDialog" :dialog="senderDialog" :tableDisplay="tableDisplay" :search="search" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DocumentTable from "../../components/documents/DocumentList";
import DocumentTypesTable from "../../components/documents/DocumentTypeList";
import InitiatedDocumentTable from "../../components/documents/InitiatedDocumentsList";
import DocumentCategoriesList from "../../components/documents/DocumentCategoriesList.vue"
import SendersTable from "../../components/documents/Senders";

export default {
  name: "Documents",
  components: {
    DocumentTable,
    DocumentTypesTable,
    InitiatedDocumentTable,
    DocumentCategoriesList,
    SendersTable,
  },
  data() {
    return {
      isFetchingDocumentsCategories: false,
      isFetchingDocumentsTypes: false,
      isFetchingDocuments: false,
      search: "",
      tableDisplay: "documents",
      category_label: "Categories",
      types_label:"Types",
      dateRange: {
        startDate: '',
        endDate: ''
      },
      category: [],
      types:[],
      dialog: false,
      typeDialog: false,
      categoryDialog: false,
      senderDialog: false,
    };
  },
  methods: {
    ...mapActions([
      "fetchDocumentTypes",
      "fetchDocuments",
      "fetchInitiatedDocuments"
    ]),
    openDialog(val){
      if(val == "types")
      this.typeDialog = true
      if(val == "categories")
      this.categoryDialog = true
    },
    closeDialog(val){
      console.log("closing dialog")
      this.dialog = val;
      this.typeDialog = val;
      this.categoryDialog = val;
      this.senderDialog = val
    },
    onSelectDates(value){
      this.dateRange = value
    },
    getCategory(v){
      console.log(v)
    },
    getTypes(v){
      console.log(v)
    },
    checker(){
      if(this.allDocumentCategories.length == 0)
        this.isFetchingDocumentsCategories = true
      if(this.allDocuments.length == 0)
        this.isFetchingDocuments = true
      if(this.allDocumentTypes.length == 0)
        this.isFetchingDocumentsTypes = true
    }
  },
  computed: mapGetters([
    "loggedInPosition",
    "allDocuments",
    "allDocumentTypes",
    "allDocumentCategories"
  ]),
  created() {
    this.checker()
    this.fetchDocuments({ itemsPerPage: 0 }).then(() => {
      this.isFetchingDocuments = false
    });
    this.fetchDocumentTypes().then(() => {
      this.isFetchingDocumentsTypes = false;
    });
    this.fetchInitiatedDocuments().then(() => {
      this.isFetchingDocumentsCategories = false;
    });
  }
};
</script>

<style>
.flex-container {
  display: flex;
}
.flex-container > .flex-c{
  margin: 10px;
}
.calendars {
  flex-wrap: unset !important;
  margin: 0 auto;
}
.reportrange-text[data-v-79d7c92a] {
  display: none !important;
}
</style>
